import React, { PureComponent } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';
import appConstant from '../../../constants/app';
import ModalComponent from '../../components/complex/modalComponent';

class BannerView extends PureComponent {
  state = {
    isActive: false,
    title: '',
    body: '',
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  confirmSubmit = (action) => {
    this.onToggleModal();

    this.setState({
      title: `Are you sure you want to execute this action?`,
      body: this.bodyContent(action)
    });
  }

  bodyContent = (action) => {
    return (
      <div className="confirmation-modal-body">
        
        <Row className="confirmation-btns-footer">
          <Col sm={12}>
            <Button
              className="cancel-btn"
              onClick={() => { this.onToggleModal() }}
            >
              Cancel
            </Button>
            <Button
              className="accept-btn"
              onClick={() => { this.bannerSubmit(this.props.data.id, action) }}
            >
              Accept
            </Button>
          </Col>
        </Row>
      </div>
    )
  }

  bannerSubmit = (id, action) => {

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/banner/${action}?access_token=${localStorage.getItem('token')}`, 
      data: {
        id: id,
      },
    })
    .then(res => {
      this.onToggleModal();
      this.props.back();
    }).catch(err => {
      console.log(err);
    });
  }

  renderBackgroundType = () => {
    if(this.props.data.background_type === 1) {
      return <div className="option-background" >
        <div className="option-color-background"
        ></div>
        <div class="label-option">
          <div className="title-option">
            Gray
          </div>
        </div>
      </div>
    } else if (this.props.data.background_type === 2) {
      return <div className="option-background" >
          <div
            style={{
              height: '89px',
              width: '129px',
              backgroundColor: '#0d1f3f',
            }}
          ></div>
        <div class="label-option">
          <div className="title-option">
            Dark Blue
          </div>
        </div>
      </div> 
    } else {
      return <div className="option-background" >
          <div
            style={{
              height: '89px',
              width: '129px',
              backgroundColor: '#d0c195',
            }}
          ></div>
        <div class="label-option">
          <div className="title-option">
            Gold
          </div>
        </div>
      </div>
    }
  }

  render() {
    let button;
    const roleId = +localStorage.getItem('roleId');

    if (this.props.data.approved === 0 && this.props.data.published === 0) {
      let labelBtn;

      if (roleId === 1) {
        labelBtn = 'Publish';
      } else if (roleId === 2) {
        labelBtn = 'Submit';
      }

      button = <Button style={{marginLeft: '10px'}} className="accept-btn" onClick={() => { this.confirmSubmit("submit") }}>{labelBtn}</Button>;
    } else if (this.props.data.approved === 0 && this.props.data.published === 1) {
      if (roleId === 1) {
        button = <div>
          <Button style={{marginLeft: '10px'}} onClick={() => { this.confirmSubmit("unpublish") }}>Disapprove</Button>
          <Button style={{marginLeft: '10px'}} className="accept-btn" onClick={() => { this.confirmSubmit("publish") }}>Publish</Button>
        </div>;
      }
    } else if (this.props.data.approved === 1) {
      if (roleId === 1) {
        button = <Button style={{marginLeft: '10px'}} onClick={() => { this.confirmSubmit("unpublish") }}>Unpublish</Button>;
      }
    }

    const {
      isActive,
      title,
      body,
    } = this.state;

    return (
      <div>
        <Row>
          <Col className="adminbanner-section" sm={8}>
            <div className="title-adminbanner-wrapper">
              <h2 className="title-adminbanner" >{this.props.data.title}</h2>
            </div>

            <h3 className="title-content-section">Content</h3>
            <Row className="background-admin-wrapper">
              <div className="title-background-admin-wrapper">
                <p className="title-background-admin">
                  Background
                </p>
              </div>
              <Col className="background-body" style={{marginBottom: '20px'}} sm={12}
              >
                { this.renderBackgroundType() }
              </Col>
            </Row>
            <Row>
              <Col className="title-input-content" sm={12}>
                <label className="title-content-input">Title</label>
                <p>{this.props.data.title}</p>
                
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <label>Content</label>
                <p>{this.props.data.content}</p>
              </Col>
            </Row>
            <h3 className="period" >Appearance Period</h3>
            <Row>
              <Col sm={12}>
                <label>First date</label>
                <p>{this.props.data.first_date}</p>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <label>Last date</label>
                <p>{this.props.data.last_date}</p>
              </Col>
            </Row>
            <Row
              className="buttons-row">
              <Col sm={12} style={{display: 'flex'}}>
                <Button
                  className="cancel-btn"
                  onClick={this.props.back}
                >
                  Back
                </Button>
                {button}
              </Col>
            </Row>
          </Col>
        </Row>
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </div>
    )
  }
}

export default BannerView;


// WEBPACK FOOTER //
// ./src/app/screens/banners/bannerView.js